import { Form, Formik, FormikHelpers } from 'formik';
import { MdQrCodeScanner } from 'react-icons/md';
import AcademiaButton from '../Buttons/AcademiaButton';
import AcademiaInputField from '../Inputs/AcademiaInputField';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const ForgotPasswordModal = ({
  handleModalClose,
}: {
  handleModalClose: () => void;
}) => {
  // handler function to send verification code for forgot password feature declared here
  const passwordFormSubmissionHandler = async (
    values: any,
    actions: FormikHelpers<any>
  ) => {
    try {
      actions.setSubmitting(true);
    } catch (error) {
    } finally {
      actions.setSubmitting(false);
    }
  };

  // rendering forgot password modal component here
  return (
    <ParentModal onClick={handleModalClose}>
      <ModalTitle titleText='Forgot password?' />

      <p className='text-base-dark-blue'>
        Please, enter your email below so that we can send you a verification
        code.
      </p>

      <Formik
        initialValues={{ email: '' }}
        // validationSchema={forgotPasswordFormSchema}
        onSubmit={passwordFormSubmissionHandler}
      >
        {(props) => (
          <Form className='space-y-5'>
            <AcademiaInputField
              type='email'
              name='email'
              label='Email'
              placeholder='Enter email to get verification code...'
              isRequired
            />

            <AcademiaButton
              type='submit'
              icon={<MdQrCodeScanner className='size-5' />}
              isLoading={props.isSubmitting}
              fullWidth
            >
              Send Verification Code
            </AcademiaButton>
          </Form>
        )}
      </Formik>
    </ParentModal>
  );
};

export default ForgotPasswordModal;
